import {
    ListTableColumn,
    createListTableColumns,
    renderBooleanIconWithTooltip,
    renderBooleanIcon,
    renderClickableLink
} from "sprint-common-web";

import { renderBuzzItem } from "../../../../common/components/BuzzItem";
import { AddEpisodeToMergeListButton } from "./buttons/AddEpisodeToMergeListButton";
import { ViewEpisodeAssetButton } from "./buttons/ViewEpisodeAssetButton";
import { EpisodeListingItem } from "./EpisodeListingItem";

export const createEpisodeListingColumn = (
    onEpisodeSelected: (episode?: EpisodeListingItem) => void
): ListTableColumn<EpisodeListingItem>[] =>
    createListTableColumns<EpisodeListingItem>([
        {
            type: "interactive",
            key: "title",
            name: "Title",
            minWidth: 70,
            maxWidth: 350,
            isSortable: true,
            isDisabled: (item) => item.merged || false,
            onItemInvoked: onEpisodeSelected,
            onRender: renderClickableLink
        },
        {
            type: "basic",
            key: "episodeNumber",
            name: "Episode Number",
            minWidth: 130,
            maxWidth: 130,
            isSortable: true
        },
        {
            type: "basic",
            key: "orphaned",
            name: "Orphaned",
            minWidth: 65,
            maxWidth: 65,
            isSortable: false,
            onRender: (item?: EpisodeListingItem, number?: number, column?: ListTableColumn<unknown>) =>
                renderBooleanIconWithTooltip(item, number, column, item?.orphanedDetails)
        },
        {
            type: "basic",
            key: "merged",
            name: "Merged",
            minWidth: 65,
            maxWidth: 65,
            isSortable: false,
            onRender: renderBooleanIcon
        },
        {
            type: "basic",
            key: "buzz",
            name: "Buzz",
            minWidth: 120,
            maxWidth: 400,
            isSortable: false,
            onRender: (item) => {
                return renderBuzzItem(item?.buzz);
            }
        },
        {
            type: "buttons",
            key: "actions",
            name: "Actions",
            minWidth: 64,
            maxWidth: 96,
            buttons: [
                {
                    id: "viewAssets",
                    render: ViewEpisodeAssetButton
                },
                {
                    id: "AddEpisodeToMergeList",
                    render: AddEpisodeToMergeListButton
                }
            ]
        }
    ]);
